const MASKED_LAST4 = /(?:[*•●∙·x×]{2,}|\bxxxx)\s*-?\s*\d{4}\b/i;
const ENDING_IN_LAST4 =
  /\b(?:ending in|acct|account|card)\s*[#:]?\s*\D*\d{4}\b/i;

const CREDIT_TYPES = new Set([
  'credit_card',
  'creditcard',
  'credit',
  'debt',
  'liability',
  'loan',
  'mortgage',
]);

const CREDIT_HINTS = [
  'credit card',
  'credit-card',
  'visa',
  'mastercard',
  'master card',
  'amex',
  'american express',
  'discover',
];

const SPEND_MERCHANTS = [
  'costco',
  'rogers',
  'fido',
  'koodo',
  'telus',
  'bell canada',
  'bell mobility',
  'freedom mobile',
  'walmart',
  'amazon',
  'best buy',
  'canadian tire',
  'loblaws',
  'shoppers',
  'sobeys',
  'no frills',
  'metro ',
  'target',
];

const INVESTMENT_HINTS = [
  'rrsp',
  'tfsa',
  'fhsa',
  'resp',
  'rrif',
  'lira',
  'ira',
  'roth',
  '401k',
  '401(k)',
  'brokerage',
  'pension',
  'hoopp',
  'wealthsimple',
];

function includesAny(hay: string, hints: string[]): boolean {
  return hints.some((hint) => hay.includes(hint));
}

/**
 * Credit-card / merchant / statement rows that leaked into portfolio snapshots.
 * Hidden from Wealth + Home — they belong on Cards, not holdings.
 */
export function isSpendLikePortfolioAccount(account: {
  label?: string;
  type?: string;
}): boolean {
  const type = account.type?.trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (type && CREDIT_TYPES.has(type)) return true;

  const label = (account.label ?? '').trim();
  if (!label) return false;

  const hay = label.toLowerCase();
  if (includesAny(hay, INVESTMENT_HINTS)) return false;
  if (MASKED_LAST4.test(label) || ENDING_IN_LAST4.test(label)) return true;
  if (includesAny(hay, CREDIT_HINTS)) return true;
  if (includesAny(hay, SPEND_MERCHANTS)) return true;
  return false;
}

/** Resolve investment vs other-asset for synced portfolio rows. */
export function isPortfolioInvestmentAccount(account: {
  isInvestment?: boolean;
  type?: string;
}): boolean {
  if (account.isInvestment === false) return false;
  if (account.type?.trim().toLowerCase() === 'other') return false;
  return true;
}
